<template>
  <AbsPopup id="CertPopup" :title="title" type="alert" :initButtonList="buttonList" @close="$emit('close')">
    <template #body>
      <div class="popup-body">
        <span v-html="description"></span>
        <ul>
          <li>
            <span class="title"><b>인증코드</b></span><span class="require">*</span>
          </li>
          <li>
            <UInput type="text" line="bottom" :placeholder="palceholderText" v-model="cert" @enter="checkCert"/>
            <Ubutton text="확인" size="xxsmall" iconSize="xsmall" :state="certState" @click.native="checkCert"/>
            <Ubutton v-if="isJoin" text="재발송" size="xxsmall" iconSize="xsmall" state="deactive" @click.native="reCert"/>
          </li>
          <li class="error">
            <span :class="certErrorState">{{ certError }}</span>
          </li>
        </ul>
        <div :class="resultDesriptionLine" v-html="resultDesription">
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
// import {toTime} from '@/components/js/Utils.js'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    // console.log(this.option)
    this.resultDesription = '<span class="active">' + this.email + '</span><span>(으)로 <br />인증 코드를 전송하였습니다.<br />해당 ' + this.getStateTypeString + this.descriptionStateText + ' 확인해 주시기 바랍니다.</span>'
    this.$emit('loading', false)
  },
  beforeDestroy () {
    clearInterval(this.timeInterval)
  },
  data () {
    return {
      cert: '',
      certState: 'disable',
      certError: '',
      certErrorState: 'require',
      certButtonState: 'deactive',
      resultDesription: '',
      resultDesriptionLine: ''
    }
  },
  name: 'CertPopup',
  watch: {
    cert (val) {
      if (val.length !== 0 && (val.length < 9 || val.length > 13)) {
        this.certError = '인증코드를 정확히 입력해 주세요'
        this.certErrorState = 'require'
        this.certState = 'disable'
      } else {
        this.certError = ''
        this.certErrorState = 'require'
        this.certState = 'deactive'
      }
    }
  },
  computed: {
    isJoin () {
      switch (this.option.param.type) {
        case 'join' :
          return true
        case 'AccountSearch' :
        case 'account' :
        case 'dormancy' :
        default :
          return false
      }
    },
    title () {
      switch (this.option.param.type) {
        case 'join' :
        case 'AccountSearch' :
        case 'account' :
          return '인증하기'
        case 'dormancy' :
          return '휴면 계정 해제하기'
      }
    },
    description () {
      switch (this.option.param.type) {
        case 'join' :
          return '스담에 가입하신 것을 환영합니다.<br />이메일 인증이 완료되면 정상적으로 서비스 이용이 가능합니다.'
        case 'AccountSearch' :
        case 'account' :
          return this.getStateTypeString + ' 인증을 통해 ' + this.getTypeString + this.descriptionTypeText + ' 완료해 주세요'
        case 'dormancy' :
          return '정보통신망 이용촉진 및 정보보호 등에 관한 법률에 의거하여 1년 이상<br /> 스담 서비스를 이용하지 않은 회원님들은 휴면 계정으로 전환 됩니다.'
      }
    },
    buttonList () {
      return [
        {name: this.certButtonString, state: this.certButtonState, click: this.certButtonClick}
      ]
    },
    getStateTypeString () {
      if (this.option.param.state === 0) {
        return '이메일'
      } else {
        return '전화번호'
      }
    },
    getTypeString () {
      switch (this.option.param.type) {
        case 'join' :
          return '회원가입'
        case 'AccountSearch' :
          return '계정찾기'
        case 'account' :
          return '이메일 변경'
      }
    },
    descriptionStateText () {
      if (this.option.param.state === 0) {
        return '을'
      } else {
        return '를'
      }
    },
    descriptionTypeText () {
      switch (this.option.param.type) {
        case 'join' :
        case 'account' :
          return '을'
        case 'AccountSearch' :
          return '를'
      }
    },
    palceholderText () {
      return this.getStateTypeString + '로 받으신 인증코드를 입력해 주세요'
    },
    certButtonString () {
      switch (this.option.param.type) {
        case 'join' :
          if (this.certErrorState === 'active' && this.certState === 'active') {
            return '로그인하기'
          } else {
            return '가입취소'
          }
        case 'AccountSearch' :
        case 'account' :
          if (this.certErrorState === 'active' && this.certState === 'active') {
            return '완료'
          } else {
            return '취소하기'
          }
        case 'dormancy' :
          if (this.certErrorState === 'active' && this.certState === 'active') {
            return '로그인하기'
          } else {
            return '취소하기'
          }
      }
    },
    email () {
      return this.option.param.email
    }
  },
  methods: {
    reCert () {
      this.$emit('loading', true)
      this.$http.post('/api/auth/reCert', {email: this.email, type: this.option.param.type, state: this.option.param.state}).then(e => {
        console.log(e)
        this.$emit('loading', false)
        if (e.success) {
          this.cert = ''
        } else {
          this.alert({message: '<span class="require">인증 요청 제한 횟수를 초과 했습니다.<br />1시간 후에 다시 시도해 주세요</span>', description: '문의사항이 있으시면 아래 주소로 문의 바랍니다<br />support@tmeka.com', icon: '107', require: true}, e => {
            this.$router.push('/')
            this.$emit('close')
          })
        }
      })
    },
    certButtonClick () {
      switch (this.option.param.type) {
        case 'join' :
          if (this.certErrorState === 'active' && this.certState === 'active') {
            this.$router.push('/auth/login')
            this.$emit('close')
          } else {
            clearInterval(this.timeInterval)
            this.$router.push('/')
            this.$emit('close')
          }
          break
        case 'AccountSearch' :
        case 'account' :
          if (this.certErrorState === 'active' && this.certState === 'active') {
            this.$emit('submit', {success: true})
          } else {
            this.$emit('close')
          }
          break
        case 'dormancy' :
          if (this.certErrorState === 'active' && this.certState === 'active') {
            this.$router.push('/auth/login')
            this.$emit('close')
          } else {
            this.$emit('close')
          }
          break
      }
    },
    cutString (st) {
      return (st.length > 10) ? st.substring(0, 20) + '...' : st
    },
    checkCert () {
      if (this.certState === 'deactive') {
        this.$http.post('/api/auth/confirmUser', {email: this.email, token: this.cert, type: this.option.param.type, state: this.option.param.state}).then((e) => {
          console.log(e)
          if (e.success) {
            this.certError = '인증이 확인 되었습니다.'
            this.certErrorState = 'active'
            this.certState = 'active'
            this.certButtonState = 'in-active'
            console.log(this.option.param.type, this.option.param.type === 'AccountSearch')
            switch (this.option.param.type) {
              case 'dormancy' :
                this.resultDesription = '<span>회원님의 계정이 휴면계정에서 일반계정으로 전환되었습니다.<br />지금 로그인하여 새로운 작품과 인기 작가들을 만나보세요</span>'
                this.resultDesriptionLine = 'line'
                break
              case 'AccountSearch' :
                this.resultDesription = '<span class="active">' + this.email + '</span><span>(으)로 <br />신규 비밀번호를 전송하였습니다.<br />해당 ' + this.getStateTypeString + this.descriptionStateText + ' 확인해 주시기 바랍니다.</span>'
                break
            }
            if (this.timeString !== '') {
              this.timeString = ''
              clearInterval(this.timeInterval)
            }
          } else {
            // 통신에러?
            if (e.state === 1) {
              this.certError = '인증코드가 잘못 입력되었습니다. 다시 확인후 입력해 주세요.'
              this.certErrorState = 'require'
              this.certState = 'deactive'
            } else {
              this.certError = ''
              this.certErrorState = 'require'
              this.certState = 'deactive'
            }
          }
        })
      }
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#CertPopup {
  padding: 10px 0;
  width: 500px;
  color: var(--text-base);
}
.popup-body {
  display: flex;
  flex-direction: column;
  margin: 5px 0px;
  padding: 10px;
  align-items: center;
}
.popup-body ul {
  padding-top: 30px;
  list-style: none;
  display: flex;
  width: 400px;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.popup-body ul .input {
  flex: 1;
  height: 100%;
  margin-right: 10px;
}
.popup-body ul .error {
  display: flex;
  height: 35px;
  align-items: center;
  margin-bottom: 10px;
}
.popup-body > ul li {
  display: flex;
  align-items: center;
  height: 30px;
  width: 400px;
}
.popup-body .input {
  flex: 1;
  height: 100%;
  margin-right: 10px;
}
.popup-body button {
  margin-left: 10px;
}
.popup-body div:last-child {
  box-sizing: border-box;
  width: 400px;
  margin-bottom: 10px;
}
.popup-body div:last-child.line {
  padding: 20px 0px;
  border: 1px solid var(--disable);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/CertPopup.vue